/*
 * Copyright (c) 2025. Haodong JU
 */

import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMemberSelectorDialogStore = defineStore('member-selector-dialog', () => {
  // State
  const isVisible = ref(false)
  const title = ref('选择会员')
  const multiple = ref(true)
  const initialSelection = ref([])
  const resolvePromise = ref(null)
  const rejectPromise = ref(null)
  const returnMode = ref('membership') // 'membership' or 'user'

  // Actions
  function openDialog (options = {}) {
    // Set dialog options
    title.value = options.title || '选择会员'
    multiple.value = options.multiple !== undefined ? options.multiple : true
    initialSelection.value = options.initialSelection || []
    returnMode.value = options.returnMode || 'membership' // Default to membership IDs

    // Show the dialog
    isVisible.value = true

    // Return a promise that will be resolved when the dialog is closed
    return new Promise((resolve, reject) => {
      resolvePromise.value = resolve
      rejectPromise.value = reject
    })
  }

  function confirmSelection (selectedIds) {
    // Hide the dialog
    isVisible.value = false

    // Resolve the promise with the selected member IDs
    if (resolvePromise.value) {
      resolvePromise.value(selectedIds)
    }

    // Reset the state
    resetState()
  }

  function cancelSelection () {
    // Hide the dialog
    isVisible.value = false

    // Reject the promise
    if (rejectPromise.value) {
      rejectPromise.value('Selection cancelled')
    }

    // Reset the state
    resetState()
  }

  function resetState () {
    resolvePromise.value = null
    rejectPromise.value = null
  }

  return {
    // State
    isVisible,
    title,
    multiple,
    initialSelection,
    returnMode,

    // Actions
    openDialog,
    confirmSelection,
    cancelSelection
  }
})

// Helper function to open the member selector dialog from anywhere in the application
export function openMemberSelectorDialog (options = {}) {
  const store = useMemberSelectorDialogStore()
  return store.openDialog(options)
}
